
export function email(v) {
  if (!v) {
    return true
  }
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(v) || 'Invalid e-mail.'
}

export function validPhone(phone) {
  const re = /^1\d{10}$/
  return re.test(phone)
}

export function validOtherPhone(phone) {
  const re = /^\d{6,14}$/
  return re.test(phone)
}

export function validRequired(v) {
  return !!v || '请输入'
}

export function validRequiredSelect(v) {
  if (v === 0) {
    return !!v.toString() || '请选择'
  } else if (Array.isArray(v)) {
    return v.length > 0 || '请选择'
  } else {
    return !!v || '请选择'
  }
}

export function validEmail(v) {
  if (!v) {
    return true
  }
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(v) || '邮箱格式不正确'
}

export function validCode(code) {
  return String(code).length === 6 || '请输入6位验证码'
}

export function captchaCode(code) {
  return String(code).length === 4 || '请输入4位验证码'
}

export function gpaCode(code) {
  return String(code).length === 3 || '最多输入3位数的GPA'
}

